import { TitlePage, ContainerPage } from "components";
import { useAuth } from "hooks/useAuth";
import { Redirect } from "react-router-dom";

const DASHBOARD_PERMISSIONS = ["Stock View", "Tech", "Admin"];

export default function Default() {
  const { permissions } = useAuth();

  const canSeeDashboard = DASHBOARD_PERMISSIONS.some(permission =>
    permissions.includes(permission)
  );

  if (canSeeDashboard) {
    return <Redirect to="/app/dashboard" />;
  }

  return (
    <ContainerPage>
      <TitlePage>Quadro de avisos</TitlePage>
      <p
        style={{
          position: "absolute",
          top: "40%",
          left: "50%",
          transform: "translateX(-50%)",
          color: "#88BC23",
          fontWeight: "bold",
          fontSize: "clamp(0.75rem, 2.5vw, 1.2rem)"
        }}
      >
        Nenhum aviso encontrado
      </p>
    </ContainerPage>
  );
}
